import { render, staticRenderFns } from "./onlineRate.vue?vue&type=template&id=674a4ae8"
import script from "./onlineRate.vue?vue&type=script&lang=js"
export * from "./onlineRate.vue?vue&type=script&lang=js"
import style0 from "./onlineRate.vue?vue&type=style&index=0&id=674a4ae8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports